<template>
	<payHeader :bgStatus="bgStatus"></payHeader>
	<div class="register-main">
		<div class="section register-wx">
			<h3 class="cloumn">绑定微信<em></em>领取礼包</h3>
			<ul>
			  <li><span>1</span>使用微信登录账号</li>
			  <li><span>2</span>关联服务号后接受账号监控通知</li>
			  <li><span>3</span>接收产品到期、变更等操作通知</li>
			</ul>
			<div class="ewm">
				<el-image :src="'data:image/png;base64,'+ewmUrl" style="width: 160px;">
					<template #error>
					  <div class="image-slot" style="margin-top: 32px; color: #999;">加载中...</div>
					</template>
				</el-image>
			</div>
			<span class="go" @click="authChang">跳过，以后设置（跳转到实名认证）</span>
		</div>
	</div>
	<payFooter></payFooter>
</template>

<script setup>
	import { ref,reactive,onMounted,onBeforeUnmount} from 'vue';
	import { useRouter } from 'vue-router';
	import { wechatStatus,wechatBind } from '@/api/home';
	import { getUserInfo } from '@/api/account';
	import { payHeader,payFooter } from 'landui-ui';
	
	const router = useRouter();
	const bgStatus = ref(true);
	const ewmUrl = ref('');
	const ewmFlag = ref(true);
	let timerId = null;
	
	const getUserInfoF = () => {
		wechatStatus().then((res) => {
			if (res.code == 200) {
				if (res.data.isSubWechat == 1) {
					clearInterval(timerId);
					authChang()
				}else{
					if (ewmFlag.value) {
						wechatBindF()
					}
				}
			}
		})
	}
	const authChang = () => {
		getUserInfo().then((res) => {
			if(res.code === 200){
				if (res.data.authStatus == 1) {
					router.push({ path: '/account' })
				}else{
					router.push({ path: '/registerAuth' })
				}
			}
		})
	}
	const wechatBindF = () => {
		wechatBind().then((res) => {
			if (res.code == 200) {
				ewmUrl.value = res.data.ewm;
				ewmFlag.value = false;
			}
		})
	}
	
	onMounted(() => {
		getUserInfoF()
		timerId = setInterval(getUserInfoF, 2000);
	});
	onBeforeUnmount(() => {
	  clearInterval(timerId); 
	});
	
</script>

<style lang="scss" scoped>
	.register-wx{
		text-align: center;
		.cloumn{
			margin: 20px 90px 35px; 
			font-size: 20px;
			overflow: hidden;
			em{ width: 6px; height: 6px; border-radius: 100%; display: inline-block; vertical-align: top; background: #333; margin: 10px 12px 0;}
		}
		.cloumn:before,.cloumn:after{content: ""; height: 1px; background: #ddd; width: 290px; margin-top: 13px;}
		.cloumn:before{float: left}
		.cloumn:after{float: right}
		ul{ 
			margin-left: 390px;
			text-align: left; 
			color: #666666;
			overflow: hidden;
			li{margin-bottom: 10px; line-height: 20px;overflow: hidden}
			span{background: #666; float: left; margin: 1px 12px 0 0; border-radius: 100%; width: 18px; height: 18px; line-height: 18px; text-align: center; color: #fff;}
		}
		.ewm{width: 170px; height: 170px; padding: 4px; border: 1px solid #DDDDDD; margin: 20px auto 30px;}
		.go{display: inline-block; cursor: pointer; padding-bottom: 5px; color: #999;border-bottom: 1px dashed #999999;}
		.go:hover{ color: #015BFE;}
	}
</style>